import { CustomerResource } from '@/api/serverApi'
import { MailInviteIcon, Modal } from '@cfs-fixings/shared'
import InviteTeamMemberForm from '@/components/forms/team-members/InviteTeamMemberForm'

const textSpec = {
  'title': 'Invite Users to',
}

type PropTypes = {
  isOpen: boolean
  onClose: () => void
  customer: CustomerResource
}

const InviteTeamMemberModal = ({ isOpen, onClose, customer }: PropTypes) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={() => onClose()}
        size="lg"
        title={<div className="flex gap-2.5 items-center">
          <MailInviteIcon className="p-2 h-10 bg-primary-600 w-10 rounded-md" />
          {textSpec.title} {customer.name}
        </div>}
        content={(
          <InviteTeamMemberForm
            customer={customer}
            onSuccess={() => onClose()}
            onCancel={() => onClose()}
          />
        )}
      />
    </div>
  )
}

export default InviteTeamMemberModal
